import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { authHeaders } from '../services/auth';
import './ApiKeyPanel.css';

const WORKER = process.env.REACT_APP_WORKER_URL || '';

export default function ApiKeyPanel({ onClose }) {
  const { t } = useTranslation();
  const [hasKey,   setHasKey]   = useState(false);
  const [input,    setInput]    = useState('');
  const [status,   setStatus]   = useState('');
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    fetch(`${WORKER}/api/user/gemini-apikey`, { headers: authHeaders(), credentials: 'include' })
      .then(r => r.json())
      .then(d => setHasKey(!!d.hasKey))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    const key = input.trim();
    if (key.length < 20) {
      setStatus(t('settings.error_format'));
      return;
    }
    setStatus(t('settings.saving'));
    try {
      const r = await fetch(`${WORKER}/api/user/gemini-apikey`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        credentials: 'include',
        body: JSON.stringify({ apiKey: key }),
      });
      if (r.ok) { setHasKey(true); setInput(''); setStatus(t('settings.saved')); }
      else { const e = await r.json(); setStatus(e.error || t('settings.error_save')); }
    } catch { setStatus(t('settings.error_save')); }
  };

  const remove = async () => {
    setStatus('...');
    try {
      const r = await fetch(`${WORKER}/api/user/gemini-apikey`, { method: 'DELETE', headers: authHeaders(), credentials: 'include' });
      if (r.ok) { setHasKey(false); setInput(''); setStatus(t('settings.deleted')); }
    } catch { setStatus(t('settings.error_save')); }
  };

  return (
    <div className="akp-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="akp-box">
        <div className="akp-header">
          <span>🤖 API KEY GEMINI</span>
          <button className="akp-close" onClick={onClose}>[X]</button>
        </div>

        {loading ? (
          <div className="akp-loading">...</div>
        ) : (
          <>
            <div className={`akp-badge ${hasKey ? 'ok' : ''}`}>
              {hasKey ? t('settings.key_active') : t('settings.key_none')}
            </div>

            <div className="akp-field">
              <div className="akp-label">Gemini API Key</div>
              <div className="akp-hint">
                Ottieni la chiave su aistudio.google.com → API Keys.<br/>
                La chiave non verrà mostrata dopo il salvataggio.
              </div>
              <input
                className="akp-input"
                type="password"
                placeholder={t('settings.api_key_placeholder')}
                value={input}
                onChange={e => { setInput(e.target.value); setStatus(''); }}
                onKeyDown={e => e.key === 'Enter' && save()}
              />
            </div>

            <div className="akp-info">{t('settings.info')}</div>

            <div className="akp-actions">
              <button className="akp-save" onClick={save} disabled={!input.trim()}>
                {t('settings.save')}
              </button>
              {hasKey && (
                <button className="akp-delete" onClick={remove}>
                  {t('settings.delete')}
                </button>
              )}
            </div>

            {status && <div className="akp-msg">{status}</div>}
          </>
        )}
      </div>
    </div>
  );
}
